export const environment = {
  main_country: 'GB',
  main_brand: 'SONICARE',
  know_countries:  [
    {code: 'GB', name: 'United Kingdom'},
    {code: 'IE', name: 'Ireland'}
  ],
  known_languages: ['en'],
  current_language: 'en',
  tawkto_url: {
    en: 'https://embed.tawk.to/6229dce2a34c2456412a624f/1ftpodlht' // only EN
  },
  currency: 'GBP',
  shop_vat_rate: 0.20, // UK VAT

  zoom_guide_available: false,
  sonicare_available: false,
  assets_available: false,
  studies_available: true,
  
  ftu_available: false,
  allow_reception: false,
  allow_students: false,
  allow_edit_invoice: false,
  allow_remarks: true,
  
  notice: {
    en: '<p>Because of an internal system change, we are not able to deliver orders from April 20th until May 3rd. As of May 4 deliveries of orders to customers will return to normal. We kindly ask you to place orders <b>before April 20th 2023</b> to avoid any disruptions or delays to your orders.</p>'
    + '<p>Thank you for your understanding.</p>'
  },

  // BASE_URL: 'https://api.dentalprofessionalshop.philips.co.uk',
  // DEV_BASE_URL: 'https://api.dentalprofessionalshop.philips.co.uk',

  BASE_URL: 'https://dentalshop-uk.appspot.com',
  DEV_BASE_URL: 'https://dentalshop-uk.appspot.com',
  

  ADMIN_BASE: 'https://api.dentalprofessionalshop.philips.co.uk', // NOT NEEDED ANYMORE ?
  LOCAL_BASE_URL: 'http://localhost:8877',

  NAMESPACE: 'PHILIPSDENTALPRO',
  // DEV_NAMESPACE: 'PHILIPSDENTALPRO-TST',
  DEV_NAMESPACE: 'PHILIPSDENTALPRO',


  LOCAL_NAMESPACE: 'TST',

  send_token_in_request: true,

  production: false,

  home_content_blocks: [
    {
      styles: {
        'background-image': 'linear-gradient(180deg, rgba(0, 0, 0, 0.41), transparent 29%), url(/assets/images/background-header-uk.jpg)',
        'background-position': '0px 0px, 50% 50%',
        'height': '600px',
        'padding': '200px 20px 0 20px',
      },
      available_in: ['en'],
      contentLeft: {
        title: {
          en: '<h2 style="color: #fff">Quick and easy ordering of products for Dental Professionals.</h2>' +
              '<p style="color: #fff; font-size:24px; line-height: 28px;">Easy online ordering of ZOOM! Whitening and Sonicare products for Dental Professionals</p>',
        },
        buttons: [
          {
            type: 'internal',
            url: '/shop',
            text: {
              de: 'Online shop',
              fr: 'Magasin en ligne',
              nl: 'shop',
              en: 'Online shop'
            },
            color: 'blue'
          }
        ]
      }
    },
    {
      styles: {
        'height': '600px',
        'background-image': 'linear-gradient(180deg, rgba(11, 34, 101, .41), transparent 29%), url(https://lh3.googleusercontent.com/ToSMnXx4CWsLAdRjiJCs-YYUgJFrNv9Q6l0guxvar8IgutiwnpB_XE5ZiBfiyLCzIa32GO4fpAHw4tp9tLHWmLdC2i8f7XpZaAX7U_KBjaKoPXlGVUrIw1E28BGIlSK5NOKDsPTYMvuPWT6vAr5uEj-89LICs1Gj8v4thbhjGUZMehzkSf-q9Eu9C5dDcvmlr2hee0bKHfIsnWF9-Qnkr6TZG3P8X62EScIsJ2PbX4dkSNBedFZhj_ipvWnZpZOvW9xkM0JIwWYk0yWQCDpky3R3igSjm5UNG4nBD5RRgS7QzfhnufRFoYGWIAFmt-blZTPHFcj2bViy4Cqw_FxVYcikIwP17xEuz2km54c6CJ1U6rvjoaaDlnDE4_tXwCVpaZQcfiZqF5is8IdqJMWaXT_S94w2_5kmXC9iuKKXAlrv4iD1o8EFsn_GJk54ey4sOPqDHdbifWlai3QvwSnORXhyzJFfNNUA7VxcMN9Keogec88FPVM4Zw7r9hWbzA1R7jYJ38ZmQU9heJCBWtq1k0cYTUcUTp-k13SM0QnELSOK6jXr1YZQS-b-i-BKNH4-TS_yGYEGeDQE50dwB0pAgzwz0yPMjtpal9K_cyxww_ghepYeB9Kg5YQeZ1OMEDfoDtejBfnFGRe6nZDqOZMxPOIj2lC8kt-8kOZjNe35i-8oXeyCmdf_mnEzvx_ittoATGFhsx_gm6xUFiH6Nqk=s800)',
        'background-position': '0px 0px, 100% 50%',
        'background-size': 'auto, cover',
      },
      available_in: ['en'],
      contentLeft: {
      },
      contentRight: {

      }
    }
  ]
};



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/environments/environment.uk.ts